/**
 * MarketSubNav — shared sub-navigation bar for all Market Intelligence pages.
 * Uses useLocation() so the active pill always reflects the actual current route.
 */

import { useNavigate, useLocation } from 'react-router-dom'
import { useBreakpoint } from '../../hooks/useBreakpoint'

// The market workflow, in the order an operator works it: who's the threat,
// how do I compare, what am I missing, how are they discounting. Heat Map is
// NOT part of this navigation — the market section is analysis, not a map.
const MARKET_TABS = [
  { label: 'Rival Ranking', route: '/market/ranking' },
  { label: 'My Benchmarks', route: '/market/benchmarks' },
  { label: 'SKU Gaps',      route: '/market/sku-gaps' },
  { label: 'Deal Patterns', route: '/market/deals' },
]

export function MarketSubNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const tight = useBreakpoint().atMost('compact')

  return (
    // `data-page-nav` so the top-density spec can account for this band; it is
    // navigation, not controls, and was previously invisible to the ruler.
    <div data-page-nav="" style={{
      display: 'flex',
      background: 'var(--surface-2)',
      borderBottom: '1px solid var(--border)',
      padding: tight ? '0 18px' : '0 24px',
      flexShrink: 0,
      overflowX: 'auto',
    }}>
      {MARKET_TABS.map(tab => {
        const active = pathname === tab.route
        return (
          <div
            key={tab.route}
            onClick={() => navigate(tab.route)}
            style={{
              padding: tight ? '8px 12px' : '10px 16px',
              fontSize: 12,
              fontWeight: 600,
              color: active ? 'var(--accent)' : 'var(--text-3)',
              cursor: 'pointer',
              borderBottom: active ? '2px solid var(--accent)' : '2px solid transparent',
              whiteSpace: 'nowrap',
              flexShrink: 0,
              transition: 'color 0.15s, border-color 0.15s',
              userSelect: 'none',
            }}
            onMouseEnter={e => {
              if (!active) (e.currentTarget as HTMLElement).style.color = 'var(--text-1)'
            }}
            onMouseLeave={e => {
              if (!active) (e.currentTarget as HTMLElement).style.color = 'var(--text-3)'
            }}
          >
            {tab.label}
          </div>
        )
      })}
    </div>
  )
}
